import { PDDatos } from './PDDatos';

export class General {
    dscCampo1: string;
    numCampo1: number;
    dscCampo2: string;
    dscCampo3: string;
    dscCampo4: string;
    dscCampo5: string;
    dscCampo6: string;
    // numCampo6:string;
    flgCampo1: boolean;
    flgCampo2: boolean;
    flgCampo3: boolean;
    flgCampo4: boolean;
    flgCampo5: boolean;
    listaPdDatos: PDDatos[];
}

